import { IApplicationState } from '../../types/redux/store';

export function selectJsonQuery(state: IApplicationState) {
  return state.results.jsonQuery;
}
